import {
  CheckboxField,
  InputGroupField,
  RadioField,
  TextField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Input, Row } from "reactstrap"
import { Field, FieldArray, formValueSelector } from "redux-form"

const RegistrationTab = ({ rsvpOption, maybeOption }) => {
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>REGISTRATION</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <Field
                name="rsvpOption"
                type="radio"
                component={RadioField}
                value="0"
                label="Do not display the RSVP options"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Field
                name="rsvpOption"
                type="radio"
                component={RadioField}
                value="1"
                label="Display the RSVP options"
              />
            </Col>
          </Row>
          {rsvpOption === "1" && (
            <>
              <Row className="mt-2">
                <Col xs="auto" className="mt-2">
                  <label>
                    How many spots are available for this event? (Optional)
                  </label>
                </Col>
                <Col xs="auto">
                  <Field
                    name="availableSpots"
                    component={TextField}
                    type="number"
                    min="0"
                  />
                </Col>
              </Row>
              <Row className="my-2">
                <Col xs="auto" className="mt-2">
                  <label>Max spots allowed per RSVP?</label>
                </Col>
                <Col xs="auto">
                  <Field
                    name="maxSpot"
                    component={TextField}
                    type="number"
                    min="0"
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Field
                    name="maybeOption"
                    component={CheckboxField}
                    label="Add Maybe Option"
                  />
                </Col>
              </Row>
              {maybeOption && (
                <Row>
                  <Col className="my-1 ms-3">
                    <Field
                      name="maybeOptionSpot"
                      component={CheckboxField}
                      label="Maybes takes up a spot"
                    />
                  </Col>
                </Row>
              )}
            </>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.CALENDAR_EVENT)

const mapStateToProps = state => ({
  rsvpOption: selector(state, "registration.rsvpOption"),
  maybeOption: selector(state, "registration.maybeOption"),
})

export default connect(mapStateToProps)(RegistrationTab)
